var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-tabs-wrapper coupled bb-0 mb-1" }, [
    _c(
      "ul",
      { staticClass: "nav nav-tabs scroll-container" },
      _vm._l(_vm.pages, function (page) {
        return _c("router-link", {
          key: page,
          attrs: { id: page, to: _vm.getLinkData(page), exact: "", custom: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "default",
                fn: function (ref) {
                  var navigate = ref.navigate
                  var isExactActive = ref.isExactActive
                  return [
                    _c(
                      "li",
                      {
                        staticClass: "nav-item",
                        class: {
                          "navbar-active": isExactActive,
                        },
                        attrs: { role: "link" },
                        on: {
                          click: navigate,
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return navigate.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "nav-link grey-text text-darken-3 clickable",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.getTabTitle(page)) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ],
            null,
            true
          ),
        })
      }),
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-control scroll-left" }, [
      _c("i", {
        staticClass: "fa fa-chevron-left",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-control scroll-right" }, [
      _c("i", {
        staticClass: "fa fa-chevron-right",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }